export default __webpack_public_path__ + "static/one-pa-logo-header-58c86a5f177152edd6f66d583e6e5af4.svg";